import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import config from '../../config';

export const PrivateOutlet = () => {
  const [isLoggedIn, account] = useSelector((state) => [state.account.isLoggedIn, state.account.account]);
  return isLoggedIn && account && account.token ? <Outlet /> : <Navigate to="/login" />;
};

export const PrivateOutletNotLogin = () => {
  const [isLoggedIn, account] = useSelector((state) => [state.account.isLoggedIn, state.account.account]);
  return isLoggedIn && account && account.token ? <Navigate to="/" /> : <Outlet />;
};

export const PrivateOutletPermission = ({link}) => {
  const isLoggedIn = useSelector((state) => state.account.isLoggedIn);
  const account = useSelector((state) => state.account.account);

  const genLink = (id) => {
    switch (id) {
      case config.menu_id.dashboard: {
        return '/';
      }
      case config.menu_id.user: {
        return '/manage_user';
      }
      case config.menu_id.storage: {
        return '/manage_storage'
      }
    }
  }
  if(!isLoggedIn || !(account && account.token)){
    return <Navigate to="/login" />;
  } else {
    if(link === '/'){
      return <Outlet/>;
    }
    for(let i = 0; i < account.menu.length; i++){
      if(genLink(account.menu[i].permission._id) === link) {
        return <Outlet/>;
      }
    }
    return <Navigate to="/" />;
  }
}